import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { convertTimestampToFrenchFormat } from "../../scripts/utils";
import Loader from "../../components/Loader";
import { useTranslation } from "react-i18next";

export default function IeloContrat({ setLink, contractRef, setLinkType }) {
    const { apiUrl } = useContext(AuthContext);
    const { t } = useTranslation();

    const getContrat = async () => {
        const res = await axios(`${apiUrl}ielo/contracts/${contractRef}`, {
            method: "get",
            withCredentials: true
        });

        return res.data;
    };

    const contract = useQuery({
        queryKey: ["contract_ielo", contractRef],
        queryFn: getContrat,
        enabled: !!contractRef
    });

    if (contract.isLoading) {
        return <Loader />;
    }

    if (!contract.data) {
        return <div className="no-data">{t("Aucune donnée disponible")}</div>;
    }

    return (
        <>
            <div className="cato-header-logo mb-2">
                <div className="ecp-container-content-header">
                    <div className="ecp-container-content-header-title">
                        <div className="page-title page-logo">
                            <h1 className="page-title">Liaison internet</h1>
                        </div>
                    </div>
                </div>
                <button className="cato-header-logo-button" onClick={() => { setLink(); setLinkType(); }}>
                    <FontAwesomeIcon icon={faChevronLeft} color={"white"} />
                    {t("Retour")}
                </button>
            </div>
            <section className="mb-2">
                <article className="cato-content-model-details-summary">
                    <span className="cato-content-model-details-summary-icon">
                        <FontAwesomeIcon icon={faInfoCircle} color={"#80c353ff"} />
                    </span>
                    <p>Contrat {contract.data.reference}</p>
                </article>
            </section>
            <section className="cato-content">
                <section className="cato-content-section">
                    <div className="cato-content-model-details">
                        <h2>{t("Details du contrat")}</h2>
                        <div>
                            <h3>{t("Date de signature :")}</h3>
                            <p>{convertTimestampToFrenchFormat(contract.data.signed_at, t("en-EN"))}</p>
                        </div>
                        <div>
                            <h3>{t("Date de mise en service")} :</h3>
                            <p>{convertTimestampToFrenchFormat(contract.data.ready_for_service_at, t("en-EN"))}</p>
                        </div>
                        <div>
                            <h3>{t("Référence de la commande")} :</h3>
                            <p className="direction">{contract.data.order_reference}</p>
                        </div>
                        <div>
                            <h3>{t("Durée de l'engagement")} :</h3>
                            <p>{contract.data.commitment_months} {t("mois")}</p>
                        </div>
                    </div>
                </section>
            </section>
        </>
    );
}
